<div id="sash-layout-options">
    <mat-slide-toggle  *ngIf="changeIndividualProfiles" [checked]="drawButtons.profiles" (change)="drawButtons.toggle('profiles')">{{ 'WINDOW|Wymiana pojedynczych profili' | translate }}</mat-slide-toggle>
    <button mat-button color='primary' (click)="openPreview()">{{ 'WINDOW|Powiększenie rysunku' | translate }}</button>
</div>
<div id="sash-layout-draw" #parent>
    <icc-draw [details]="drawService.details" [options]="drawOptions" fitTo="width" iccDrawResize [drawWidth]="width$ | async" [drawHeight]="height$ | async" [parentElement]="parent"></icc-draw>
</div>
